import { getValue } from "./DataGroup";
import { ICell } from "../types";

function sort(arr: any[], dir = "asc") {
	return arr.sort((a, b) => {
		const nn = isNaN(a) ? a.localeCompare(b) : a - b;
		return dir === "asc" ? nn : -nn;
	});
}

export function getUnique(data: ICell[][], field: string, dir: string): any[] {
	const temp = {};
	for (let i = 0; i < data.length; i++) {
		if (data[i] instanceof Array && data[i].length) {
			for (let k = 0; k < data[i].length; k++) {
				temp[getValue(data[i][k][field], "id")] = data[i][k];
			}
		}
	}
	return sort(Object.keys(temp), dir).map(key => temp[key][field]);
}

export const mathMethods = {
	sum: (data: any[]) => {
		return data.reduce((prev, el) => prev + el);
	},
	min: (data: any[]) => {
		return data[0];
	},
	max: (data: any[]) => {
		return data[data.length - 1];
	},
	count: (data: any[]) => {
		return data.length;
	},
};

const defaultFormat = (val: any, method: string) => {
	if (method === "count" || typeof val === "string") {
		return val;
	} else {
		return val.toFixed(3);
	}
};

export function methods(data: any[], field: string, method: string): any {
	if (typeof data === "string") {
		return data;
	}
	if (!data.length) {
		return "";
	}
	data = data
		.map(obj => parseFloat(obj[field]) || 0)
		.sort((a: any, b: any) => (a > b ? 1 : -1)) as number[];

	return mathMethods[method] ? defaultFormat(mathMethods[method](data), method) : null;
}
